import React, { useEffect, useState } from "react";
import { Select, Form, Row, Col, Input } from "antd";
import { useDeviceSelector } from "../../../V2/components/FormRender/hooks/useDeviceSelector";

const { Option } = Select;

export const StartProcessFilter = ({
    selectedMesoProcess,
    isMesoProcessLoading,
    selectedMacroProcess,
    isMacroProcessesLoading,
    selectedStablishment,
    mesoProcesses,
    stablishments,
    isStablishmentsLoading,
    macroProcesses,
    handleStablishmentChange,
    handleMacroProcessChange,
    handleMesoProcessChange,
    onChangeGlobalFilter,
    globalFilter,
}) => {
    const [localValueFilter, setLocalValueFilter] = useState(null);

    function handleOnChangeGlobalFilter(value) {
        setLocalValueFilter(value);
    }

    useEffect(() => {
        setLocalValueFilter(globalFilter);
    }, [globalFilter]);

    const { isDesktop } = useDeviceSelector();

    return (
        <Form
            labelCol={{
                xs: { span: 24 },
                sm: { span: 24 },
                md: { span: 24 },
                lg: { span: 8 },
            }}
            wrapperCol={{
                xs: { span: 24 },
                sm: { span: 24 },
                md: { span: 24 },
                lg: { span: 16 },
            }}
            layout="horizontal"
        >
            <Row gutter={8}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <Form.Item label="Estabelecimento">
                        <Select
                            showSearch
                            allowClear
                            style={{ width: "100%" }}
                            onChange={handleStablishmentChange}
                            placeholder="Pesquise ou selecione o estabelecimento"
                            loading={isStablishmentsLoading}
                            optionFilterProp="children"
                            value={selectedStablishment === null ? undefined : selectedStablishment}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {stablishments &&
                                stablishments.map((item) => (
                                    <Option
                                        value={item.id_estabelecimento}
                                        key={item.id_estabelecimento + "_stablishments"}
                                    >
                                        {item.nome}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <Form.Item label="Macro-Processo">
                        <Select
                            showSearch
                            allowClear
                            style={{ width: "100%" }}
                            placeholder="Pesquise ou selecione o macro-processo"
                            value={selectedMacroProcess || undefined}
                            loading={isMacroProcessesLoading}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={handleMacroProcessChange}
                        >
                            {macroProcesses &&
                                macroProcesses.map(({ id_parametro, valor }) => (
                                    <Option key={id_parametro}>{valor}</Option>
                                ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <Form.Item label="Meso-Processo">
                        <Select
                            showSearch
                            allowClear
                            style={{ width: "100%" }}
                            value={selectedMesoProcess || undefined}
                            loading={isMesoProcessLoading}
                            disabled={!selectedMacroProcess ? true : false}
                            onChange={handleMesoProcessChange}
                            placeholder="Selecione um meso-processo"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {mesoProcesses &&
                                mesoProcesses.map(({ id_parametro, valor }) => (
                                    <Option key={id_parametro}>{valor}</Option>
                                ))}
                        </Select>
                    </Form.Item>
                </Col>

                {!isDesktop && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <Form.Item label="Filtro">
                            <Input.Search
                                placeholder="Código, nome ou âmbito"
                                enterButton="Pesquisar"
                                value={localValueFilter}
                                onChange={(event) => handleOnChangeGlobalFilter(event.target.value)}
                                onSearch={(value) => onChangeGlobalFilter(value)}
                            />
                        </Form.Item>
                    </Col>
                )}
            </Row>
        </Form>
    );
};
